import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import PaxForm from './PaxForm';

const ListContainer = (props) => {
  const {
    roomId,
    paxes,
    distribution,
    readOnly,
    hasToValidate
  } = props;

  useEffect(() => {
    const { adults, children } = distribution;
    const desiredPaxes = (adults + children);
    const paxesTotal = paxes.length;

    if (paxesTotal === desiredPaxes) return;

    props.handleNumberOfPaxes(roomId, desiredPaxes);
  }, [props.distribution]); // eslint-disable-line react-hooks/exhaustive-deps

  const handlePaxData = (paxData) => {
    props.handlePaxesData(roomId, paxData)
  };

  return (
    <Row className="paxes-list__container">
      {
        paxes.map((pax, index) => {
          const paxKey = `ROOM-${roomId}-PAX-${index}`;

          const customProps = (index === 0) ? { hasToValidate } : {};

          return (
            <Col sm="6" key={paxKey}>
              <PaxForm
                pax={pax}
                readOnly={readOnly}
                {...customProps}
                handlePaxData={handlePaxData}
              />
            </Col>
          )
        })
      }
    </Row>
  );
};

ListContainer.propTypes = {
  roomId: PropTypes.number.isRequired,
  paxes: PropTypes.arrayOf(PropTypes.object),
  distribution: PropTypes.shape({
    adults: PropTypes.number,
    children: PropTypes.number
  }),
  readOnly: PropTypes.bool,
  hasToValidate: PropTypes.bool,
  handlePaxesData: PropTypes.func,
  handleNumberOfPaxes: PropTypes.func
};

ListContainer.defaultProps = {
  paxes: [],
  distribution: {
    adults: 1,
    children: 0
  },
  readOnly: false,
  hasToValidate: false,
  handlePaxesData: () => {},
  handleNumberOfPaxes: () => {}
};

export default ListContainer;
